import React from 'react';
import "./index.scss";
import ReactDOM from 'react-dom/client';
import AppRoutes from './routes';

import { AuthProvider } from './context/AuthContext';
import { IconButton, ThemeProvider } from '@mui/material';
import { themeConfig } from "./utils/ThemeUtils";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { MdClose } from 'react-icons/md';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <Toaster
      position='bottom-center'
      reverseOrder={false}
      // AQUI: A função como children do Toaster, que será usada para TODOS os toasts
      children={(t) => (
        // Use ToastBar para ter o estilo padrão e a funcionalidade base
        <ToastBar
          toast={t} // Passe o objeto do toast para o ToastBar
          style={{
            // Opcional: Você pode sobrescrever estilos do ToastBar aqui para todos os toasts
            // Ex: borderRadius: '10px',
            // Se você quiser estilos diferentes para erro, fará isso abaixo
            maxWidth: '680px'
          }}
        >
          {({ icon, message }) => ( // Este é o render prop do ToastBar
            <div style={{
              display: 'flex',
              width: '100%',
              // Você pode aplicar estilos específicos aqui baseados no tipo de toast
              // Ex: se for erro, adicione um padding maior para o botão de fechar
              paddingRight: t.type === 'error' ? '40px' : '0px',
              position: 'relative'
            }}>
              {icon} {/* Renderiza o ícone padrão do toast (success, error, etc.) */}
              <span style={{ flexGrow: 1, marginLeft: '8px' }}>{message}</span> {/* A mensagem do toast */}
              {/* Condicionalmente renderize o botão de fechar APENAS para toasts de ERRO */}
              {t.type === 'error' && (
                <IconButton
                  onClick={() => toast.dismiss(t.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    position: 'absolute',
                    right: 5,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: t.style?.color || 'inherit', // Herda a cor do texto do toast
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  aria-label="fechar"
                >
                  <MdClose size={18} /> {/* Use seu ícone MdClose */}
                </IconButton>
              )}
            </div>
          )}
        </ToastBar>
      )}
      toastOptions={{
        success: {
          duration: 5000,
          style: { background: '#edf7ed', color: '#1e4620' }
        },
        error: {
          duration: Infinity,
          style: { background: '#fdeded', color: '#5f2120' }
        }
      }}
    />
    <ThemeProvider theme={themeConfig}>
      <AppRoutes />
    </ThemeProvider>
  </AuthProvider>
);